var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "biz-selector-content border-primary-6",
      class: { disabled: _vm.disabled },
    },
    [
      !_vm.singleCloseable && _vm.value[_vm.labelKey]
        ? _c("div", {}, [
            _vm._v("\n    " + _vm._s(_vm.value[_vm.labelKey] || "") + "\n  "),
          ])
        : _vm.value[_vm.labelKey]
        ? _c(
            "div",
            [
              _c(
                "yxt-tag",
                {
                  attrs: { type: "info", size: _vm.size, closable: "" },
                  on: { close: _vm.deleteTag },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.value[_vm.labelKey]) + "\n      "
                  ),
                  _vm.value.includeAll
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("pc_gwnl_selectOuter_group_lbl_includeAll")
                            ) +
                            "\n      "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm.defaultTag
        ? _c(
            "div",
            [
              _c(
                "yxt-tag",
                {
                  attrs: { type: "info", size: _vm.size, closable: "" },
                  on: { close: _vm.deleteTag },
                },
                [_vm._v("\n      " + _vm._s(_vm.defaultTag) + "\n    ")]
              ),
            ],
            1
          )
        : _c("div", [
            _c("div", { staticClass: "color-gray-6 standard-size-14 mt1" }, [
              _vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    "),
            ]),
          ]),
      _c("yxt-svg", {
        staticClass: "biz-selector-content__icon color-gray-6 hover-primary-6",
        attrs: { width: "28px", height: "28px", "icon-class": "three-dot" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }